// @flow
import _ from 'lodash'
import type { OptionType, UrlCheckResult } from '../../../components/types'
import { putRawAdvertisement, type RawAdvertisement } from '../AdvertisementDataAdapter'

type State = {|
  storeIds: Array<string>,
  providers: Array<string>,
  urlCheck: ?UrlCheckResult,
  fbPromotionPosts: Array<OptionType>,
  isLoading: boolean
|}

type PatchAction = {|
  type: 'AD_EDIT_WRAPPER.PATCH',
  state: $Shape<State>
|}

type RemoveAction = {|
  type: 'AD_EDIT_WRAPPER.REMOVE',
  storeId: string
|}

type Action = PatchAction | RemoveAction

export const patch = (diff: Object): Action => ({
  type: 'AD_EDIT_WRAPPER.PATCH',
  state: diff
})

export const init = (advertisement: RawAdvertisement) => {
  const storeIds = [putRawAdvertisement(advertisement)]
  return patch({ storeIds })
}

export const remove = (storeId: string): Action => {
  return {
    type: 'AD_EDIT_WRAPPER.REMOVE',
    storeId
  }
}

export type { State }

const initialState = {
  storeIds: [],
  providers: [],
  urlCheck: null,
  fbPromotionPosts: [],
  isLoading: false
}

export default function adEdit(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'AD_EDIT_WRAPPER.PATCH':
      return { ...state, ...action.state }
    case 'AD_EDIT_WRAPPER.REMOVE': {
      const { storeIds } = state
      const { storeId } = action
      const withoutDeleted: Array<string> = _.without(storeIds, storeId)
      return { ...state, storeIds: withoutDeleted }
    }
    default:
      return state
  }
}
